import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'admin-i18n-csv-editor',
  templateUrl: './i18n-csv-editor.html',
  styleUrls: ['./i18n-csv-editor.scss'],
})
export class I18nCsvEditor implements OnChanges {
  @ViewChild('csvField', { static: false }) csvField: ElementRef;

  @Input() csv: string;
  @Input() errorMessage: string;
  @Input() valid: boolean;
  @Input() edit: boolean;
  @Input() loading: boolean;
  @Input() saving: boolean;
  @Input() enableSave = false;

  @Output() changed = new EventEmitter<void>();
  @Output() save = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.csv) {
      this.csvField && (this.csvField.nativeElement.value = this.csv);
    }
  }
}
